export { Body1, Body2, Body3 } from '@sberdevices/plasma-core';
